import {id2xy} from "../coordinates";

export function calculateDistance(x1, y1, x2, y2) {
    let dx = Math.abs(x1 - x2);
    let dy = Math.abs(y1 - y2);
    if (dx > 401 - dx) {
        dx = 401 - dx;
    }
    if (dy > 401 - dy) {
        dy = 401 - dy;
    }
    return (dx ** 2 + dy ** 2) ** 0.5;
}

export function calculateDistanceByMapId(mapId1, mapId2) {
    const pos1 = id2xy(mapId1);
    const pos2 = id2xy(mapId2);
    return calculateDistance(pos1.x, pos1.y, pos2.x, pos2.y);
}
